// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WaiverCTA_section__gUS4d {
  background: linear-gradient(135deg, #fffbf7 0%, #fef3ff 50%, #f0f9ff 100%);
  padding: 3rem 1.5rem;
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;
  position: relative;
  overflow: hidden;
}

.WaiverCTA_section__gUS4d::before {
  content: '';
  position: absolute;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 107, 157, 0.12), transparent 70%);
  top: -60px;
  left: -60px;
  pointer-events: none;
  animation: WaiverCTA_float__pzI2I 6s ease-in-out infinite;
}

.WaiverCTA_section__gUS4d::after {
  content: '';
  position: absolute;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(124, 58, 237, 0.1), transparent 70%);
  bottom: -40px;
  right: -40px;
  pointer-events: none;
  animation: WaiverCTA_float__pzI2I 5s ease-in-out infinite reverse;
}

.WaiverCTA_visible__kohgg {
  opacity: 1;
  transform: translateY(0);
}

.WaiverCTA_inner__9KlZM {
  max-width: var(--max-width);
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 2rem;
  position: relative;
  z-index: 1;
}

.WaiverCTA_iconCircle__H1ciJ {
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(255, 107, 157, 0.3);
  animation: WaiverCTA_pulse__M7mF3 2.5s ease-in-out infinite;
}

.WaiverCTA_text__DxVtr {
  flex: 1 1;
}

.WaiverCTA_text__DxVtr h2 {
  font-family: 'Fredoka', 'Poppins', sans-serif;
  font-size: clamp(1.25rem, 3vw, 1.75rem);
  margin: 0 0 0.25rem;
  color: var(--color-text);
}

.WaiverCTA_text__DxVtr p {
  margin: 0;
  color: var(--color-text-muted);
  font-size: 1rem;
}

@keyframes WaiverCTA_pulse__M7mF3 {
  0%, 100% { transform: scale(1); box-shadow: 0 8px 24px rgba(255, 107, 157, 0.3); }
  50% { transform: scale(1.08); box-shadow: 0 12px 32px rgba(255, 107, 157, 0.45); }
}

@keyframes WaiverCTA_float__pzI2I {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
}

@media (max-width: 768px) {
  .WaiverCTA_section__gUS4d {
    padding: 2.5rem 1.25rem;
  }

  .WaiverCTA_inner__9KlZM {
    flex-direction: column;
    text-align: center;
    gap: 1.5rem;
  }
}

@media (max-width: 480px) {
  .WaiverCTA_section__gUS4d {
    padding: 2rem 1rem;
  }

  .WaiverCTA_iconCircle__H1ciJ {
    width: 56px;
    height: 56px;
  }

  .WaiverCTA_text__DxVtr h2 {
    font-size: 1.15rem;
  }

  .WaiverCTA_text__DxVtr p {
    font-size: 0.9rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .WaiverCTA_section__gUS4d {
    opacity: 1;
    transform: none;
    transition: none;
  }

  .WaiverCTA_iconCircle__H1ciJ {
    animation: none;
  }

  .WaiverCTA_section__gUS4d::before,
  .WaiverCTA_section__gUS4d::after {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/home/WaiverCTA.module.css"],"names":[],"mappings":"AAAA;EACE,0EAA0E;EAC1E,oBAAoB;EACpB,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;EAClD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,+EAA+E;EAC/E,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,yDAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,6EAA6E;EAC7E,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,iEAAgD;AAClD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iFAAiF;EACjF,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+CAA+C;EAC/C,2DAA0C;AAC5C;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,6CAA6C;EAC7C,uCAAuC;EACvC,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,WAAW,mBAAmB,EAAE,+CAA+C,EAAE;EACjF,MAAM,sBAAsB,EAAE,iDAAiD,EAAE;AACnF;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":[".section {\n  background: linear-gradient(135deg, #fffbf7 0%, #fef3ff 50%, #f0f9ff 100%);\n  padding: 3rem 1.5rem;\n  opacity: 0;\n  transform: translateY(30px);\n  transition: opacity 0.6s ease, transform 0.6s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.section::before {\n  content: '';\n  position: absolute;\n  width: 200px;\n  height: 200px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(255, 107, 157, 0.12), transparent 70%);\n  top: -60px;\n  left: -60px;\n  pointer-events: none;\n  animation: float 6s ease-in-out infinite;\n}\n\n.section::after {\n  content: '';\n  position: absolute;\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(124, 58, 237, 0.1), transparent 70%);\n  bottom: -40px;\n  right: -40px;\n  pointer-events: none;\n  animation: float 5s ease-in-out infinite reverse;\n}\n\n.visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.inner {\n  max-width: var(--max-width);\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n  position: relative;\n  z-index: 1;\n}\n\n.iconCircle {\n  flex-shrink: 0;\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 8px 24px rgba(255, 107, 157, 0.3);\n  animation: pulse 2.5s ease-in-out infinite;\n}\n\n.text {\n  flex: 1;\n}\n\n.text h2 {\n  font-family: 'Fredoka', 'Poppins', sans-serif;\n  font-size: clamp(1.25rem, 3vw, 1.75rem);\n  margin: 0 0 0.25rem;\n  color: var(--color-text);\n}\n\n.text p {\n  margin: 0;\n  color: var(--color-text-muted);\n  font-size: 1rem;\n}\n\n@keyframes pulse {\n  0%, 100% { transform: scale(1); box-shadow: 0 8px 24px rgba(255, 107, 157, 0.3); }\n  50% { transform: scale(1.08); box-shadow: 0 12px 32px rgba(255, 107, 157, 0.45); }\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-12px); }\n}\n\n@media (max-width: 768px) {\n  .section {\n    padding: 2.5rem 1.25rem;\n  }\n\n  .inner {\n    flex-direction: column;\n    text-align: center;\n    gap: 1.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .section {\n    padding: 2rem 1rem;\n  }\n\n  .iconCircle {\n    width: 56px;\n    height: 56px;\n  }\n\n  .text h2 {\n    font-size: 1.15rem;\n  }\n\n  .text p {\n    font-size: 0.9rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .section {\n    opacity: 1;\n    transform: none;\n    transition: none;\n  }\n\n  .iconCircle {\n    animation: none;\n  }\n\n  .section::before,\n  .section::after {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `WaiverCTA_section__gUS4d`,
	"float": `WaiverCTA_float__pzI2I`,
	"visible": `WaiverCTA_visible__kohgg`,
	"inner": `WaiverCTA_inner__9KlZM`,
	"iconCircle": `WaiverCTA_iconCircle__H1ciJ`,
	"pulse": `WaiverCTA_pulse__M7mF3`,
	"text": `WaiverCTA_text__DxVtr`
};
export default ___CSS_LOADER_EXPORT___;
